module.exports = __webpack_public_path__ + "static/media/higuchi-building-9.f628d94e.jpg";